<template>
  <base-popup
      :popup-model="show"
      :title="formTitle"
      :valid="!valid"
      save-button-text="Save"
      @onCancelButtonClick="closePopupHandler"
      @onSaveButtonClick="saveItemHandler"
  >
    <v-form
        :ref="formRef"
        v-model="valid"
        lazy-validation
    >
      <v-container>
        <v-row class="mt-5">
          <v-col cols="12">
            <v-text-field
                color="deep-purple accent-4"
                label="Password"
                dense
                hide-details="auto"
                prepend-icon="vpn_key"
                v-model="currentItem.password"
                :rules="[rules.required, rules.min]"
                name="password"
                type="password"
                key="signUpPassword"
                outlined
                required
            />
          </v-col>
          <v-col cols="12">
            <v-text-field
                color="deep-purple accent-4"
                dense
                hide-details="auto"
                prepend-icon="vpn_key"
                :rules="adminPasswordConfirmationRules"
                v-model="currentItem.passwordConfirmation"
                label="Confirm Password"
                name="password"
                type="password"
                key="signUpPassword"
                outlined
                required
            />
          </v-col>
        </v-row>
      </v-container>
    </v-form>
  </base-popup>
</template>
<script>
import BasePopup from "./BasePopup";
import PopupMixin from "../mixins/Popup";

export default {
  name: 'ResetPassword',
  components: {BasePopup},
  mixins: [PopupMixin],
  computed: {
    formTitle() {
      return this.isEditMode
          ? 'Reset Password'
          : 'Reset Password'
    }
  }
}
</script>
